import { IPrice } from '../../i18n/price/IPrice';
import { getAnalyticsConfig } from '../shared/config/getAnalyticsConfig';
import { trackWithGoogleAnalytics } from '../shared/trackers/trackWithGoogleAnalytics';
import { defaultCurrencyCode } from './constants/defaultCurrency';
import { adaptPriceToTrackingValue } from './adapters/adaptPriceToTrackingValue';
import { formatDate } from '../../utils/formatDate';

interface IConversionEvent {
	currency?: string;
	entryDate?: Date | undefined;
	exitDate?: Date | undefined;
	totalPrice: IPrice;
	transactionId: string;
}

export function trackConversion({
	currency,
	totalPrice,
	transactionId,
	entryDate,
	exitDate,
}: IConversionEvent) {
	trackConversionByAeroParker({
		currency,
		totalPrice,
		transactionId,
	});
	trackConversionByAdara({
		totalPrice,
		transactionId,
		entryDate,
		exitDate,
	});
}

function trackConversionByAeroParker({
	currency,
	totalPrice,
	transactionId,
}: IConversionEvent) {
	const { googleAdsTrackingId, googleAdsConversionLabel } =
		getAnalyticsConfig();

	if (!googleAdsTrackingId || !googleAdsConversionLabel) {
		return;
	}

	const sendTo = `${googleAdsTrackingId}/${googleAdsConversionLabel}`;

	trackWithGoogleAnalytics('event', 'conversion', {
		send_to: sendTo,
		value: adaptPriceToTrackingValue(totalPrice),
		currency: currency ?? defaultCurrencyCode,
		transaction_id: transactionId,
	});
}

function trackConversionByAdara({
	totalPrice,
	transactionId,
	entryDate,
	exitDate,
}: IConversionEvent) {
	const { adaraConvertionLabel, adaraTrackingId } = getAnalyticsConfig();

	if (!adaraTrackingId || !adaraConvertionLabel) {
		return;
	}

	const sendTo = `${adaraTrackingId}/${adaraConvertionLabel}`;

	trackWithGoogleAnalytics('event', 'purchase', {
		allow_custom_scripts: true,
		transaction_id: transactionId,
		value: adaptPriceToTrackingValue(totalPrice),
		u1: formatDate(entryDate, 'yyyy-MM-dd'),
		u2: formatDate(exitDate, 'yyyy-MM-dd'),
		u3: adaptPriceToTrackingValue(totalPrice),
		u4: transactionId,
		send_to: sendTo,
	});
}
